<template>
  <v-container fluid :class="$attrs.isAdmin ? 'pa-0' : ''">
    <v-card
      style="position: relative"
      class="border-radius-xl card-shadow mb-5 pb-10"
      icon="mdi-clipboard-text"
      icon-small
      color="accent"
    >
      <div class="card-header-padding my-10 mt-10">
        <div>
          <v-row>
            <v-col>
              <h5 class="font-weight-bold text-h4 text-typo mb-0">
                <span v-if="selectedZereg">
                  {{ selectedZereg.name }}
                </span>
                <span v-else> Багшийн мэргэшлийн зэрэг </span>
              </h5>
              <p class="text-typo mb-0">
                <span class="blue--text">Бөглөx талбарын тоо: </span>
                <strong>{{ completionMeter(null) }}</strong
                >,
                <span
                  >Оруулаx файлын тоо:
                  <strong>{{ _getTotalFilesNumber() }}</strong></span
                >
              </p>
              <p class="grey--text">
                Багшийн мэргэжлийн зэргийн xүсэлтийг xүлээн аваx ажлыг энд
                зоxион байгуулна.
              </p>
            </v-col>
            <v-col cols="4">
              <v-progress-linear
                rounded
                style="position: sticky; top: 0; z-index: 1000"
                :value="completionMeter(true)"
                color="#82D618"
                height="35"
                :indeterminate="loading"
              >
                <template v-slot:default="{ value }">
                  <strong v-if="loading">Хадгалж байна</strong>
                  <strong v-else
                    >{{ Math.ceil(value) }}%
                    {{ completionMeter(false) }}</strong
                  >
                </template>
              </v-progress-linear>
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col v-if="userData.role == 'teacher'">
              <p
                class="red--text mr-16"
                v-if="selectedZereg && selectedZereg._stateOfDocument == 1"
              >
                {{ formattedDate(selectedZereg.alreadyDoneAt) }}-д илгээсэн!
                ЗАСАX боломжгүй. ЗАСАX бол менежертээ xэлж цуцлуулж ЗАСАX
                боломжтой!
              </p>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="4" class="text-end">
              <v-select
                clearable
                background-color="#FAE7EE"
                @change="saveSelectedZereg()"
                :items="filteredZeregs"
                return-object
                item-text="name"
                item-value="zeregType"
                v-model="selectedZereg"
                label="Зэрэг сонгох"
                class="mt-2 mr-4"
                :disabled="$attrs.isAdmin"
              >
              </v-select>
            </v-col>
          </v-row>

          <p
            v-if="
              selectedZereg &&
              selectedZereg._stateOfDocument == 3 &&
              userData.role != 'teacher'
            "
            class="red--text text-h4"
          >
            Энэxүү xүсэлтийг цуцалсан!
          </p>

          <p
            v-if="
              selectedZereg &&
              selectedZereg._stateOfDocument == 3 &&
              userData.role == 'teacher'
            "
            class="red--text text-h4"
          >
            Энэxүү xүсэлтийг цуцалсан байна!
          </p>

          <v-btn
            v-else-if="selectedZereg && selectedZereg._stateOfDocument == 2"
            height="30"
            class="mb-2 bg-gradient-success"
            style="color: white !important"
          >
            <div style="font-size: 13pt">Баталгаажсан!</div>
          </v-btn>
          <v-form
            v-if="selectedZereg"
            ref="form"
            v-model="valid"
            lazy-validation
            :disabled="disableForm()"
          >
            <v-col
              class="pa-0"
              cols="12"
              v-for="(zereg, zindex) in zeregs"
              :key="'zereg-' + zindex"
            >
              <!-- <v-card-title>
                  <span class="font-weight-bold mr-1">{{ zindex + 1 }}.</span>
                  {{ zereg.name }} ({{ zereg.zeregType }})
                </v-card-title> -->
              <div v-if="zereg.zeregType == selectedZereg.zeregType">
                <v-card
                  class="mb-10 ml-4 card-shadow py-6"
                  v-for="(info, index) in zereg.infos"
                  :key="'info-' + index"
                  :style="
                    info.isForAdmin
                      ? $attrs.isAdmin
                        ? ''
                        : 'display: none'
                      : ''
                  "
                >
                  <v-card-title class="text-h5 text-typo">
                    {{ index + 1 }}. {{ info.name }}
                  </v-card-title>
                  <v-card-actions
                    v-if="info.typeId == 'section' && renderComponent"
                    class="mt-n1"
                  >
                    <v-col class="pa-0">
                      <div
                        class="ml-4 d-flex flex-row"
                        v-for="(field, findex) in info.fields"
                        :key="'field-' + findex"
                        @click="clic(field)"
                        :style="
                          info.isForAdmin
                            ? $attrs.isAdmin
                              ? ''
                              : 'display: none'
                            : ''
                        "
                      >
                        <span class="mt-5" :class="findex < 9 ? 'mr-6' : 'mr-4'"
                          >{{ findex + 1 }}.</span
                        >
                        <v-col
                          class="pa-0 pt-3"
                          cols="11"
                          v-if="field.typeInput == 'text'"
                        >
                          <div class="d-flex flex-row">
                            <v-text-field
                              v-if="
                                checkIfAdminOnlyForDisabled(zereg, info, field)
                              "
                              :value="
                                field.source
                                  ? field.source
                                  : 'Зөвхөн менежерт зориулагдсан'
                              "
                              :label="field.label"
                              dense
                              disabled
                            >
                            </v-text-field>

                            <v-text-field
                              v-else-if="
                                field.sourceType && field.sourceType === 'auto'
                              "
                              :value="handleAutoText(field)"
                              :label="field.label"
                              dense
                              disabled
                            >
                            </v-text-field>

                            <v-text-field
                              v-else
                              @change="formUpdated(field)"
                              :rules="field.optional ? [] : [rules.required]"
                              class="pa-0"
                              v-model="field.source"
                              :label="field.label"
                              dense
                            >
                            </v-text-field>
                            <small
                              style="color: #4caf50"
                              v-if="
                                field.sourceType && field.sourceType === 'auto'
                              "
                              >шууд бөглөсөн
                              <v-icon color="#4CAF50"
                                >mdi-check-circle</v-icon
                              ></small
                            >
                            <template v-if="field.savedAt">
                              <small
                                class="green--text ml-3 mt-2"
                                style="white-space: nowrap"
                              >
                                {{ pastFormattedDate(field.savedAt) }}
                                хадгалсан
                                <v-icon color="green" size="16" class="ml-1"
                                  >mdi-check-circle</v-icon
                                >
                              </small>
                            </template>
                          </div>
                        </v-col>
                        <v-col
                          class="pa-0 pt-3"
                          cols="11"
                          v-else-if="field.typeInput == 'number'"
                        >
                          <div class="d-flex flex-row">
                            <v-text-field
                              v-if="
                                checkIfAdminOnlyForDisabled(zereg, info, field)
                              "
                              :value="
                                field.source
                                  ? field.source
                                  : 'Зөвхөн менежерт зориулагдсан'
                              "
                              :label="field.label"
                              dense
                              disabled
                            >
                            </v-text-field>
                            <v-text-field
                              v-else
                              @change="formUpdated(field)"
                              :rules="
                                field.optional
                                  ? []
                                  : [
                                      rules.required,
                                      ...getMinMaxRules(field.min, field.max),
                                    ]
                              "
                              v-model="field.source"
                              :label="field.label"
                              dense
                              type="number"
                              :min="
                                typeof field.min === 'number' ? field.min : null
                              "
                              :max="
                                typeof field.max === 'number' ? field.max : null
                              "
                            >
                            </v-text-field>
                            <template v-if="field.savedAt">
                              <small
                                class="green--text ml-3 mt-2"
                                style="white-space: nowrap"
                              >
                                {{ pastFormattedDate(field.savedAt) }}
                                хадгалсан
                                <v-icon color="green" size="16" class="ml-1"
                                  >mdi-check-circle</v-icon
                                >
                              </small>
                            </template>
                          </div>
                        </v-col>
                        <v-col
                          class="pa-0 pt-3"
                          cols="11"
                          v-else-if="field.typeInput == 'select'"
                        >
                          <div class="d-flex flex-row">
                            <v-select
                              v-if="
                                checkIfAdminOnlyForDisabled(zereg, info, field)
                              "
                              :value="
                                field.source
                                  ? field.source
                                  : 'Зөвхөн менежерт зориулагдсан'
                              "
                              :label="field.label"
                              dense
                              disabled
                            >
                            </v-select>
                            <v-select
                              v-else-if="
                                field.sourceType && field.sourceType === 'auto'
                              "
                              :value="handleAutoText(field)"
                              :items="field.options"
                              :label="field.label"
                              dense
                              disabled
                              return-object
                              item-text="text"
                              item-value="value"
                            >
                            </v-select>
                            <v-select
                              v-else
                              @change="formUpdated(field)"
                              :rules="field.optional ? [] : [rules.required]"
                              v-model="field.source"
                              :items="field.options"
                              :label="field.label"
                              dense
                              return-object
                              item-text="text"
                              item-value="value"
                            >
                            </v-select>
                            <template v-if="field.savedAt">
                              <small
                                class="green--text ml-3 mt-2"
                                style="white-space: nowrap"
                              >
                                {{ pastFormattedDate(field.savedAt) }}
                                хадгалсан
                                <v-icon color="green" size="16" class="ml-1"
                                  >mdi-check-circle</v-icon
                                >
                              </small>
                            </template>
                          </div>
                        </v-col>
                        <v-col
                          class="pa-0 pt-3"
                          :class="field.sourceName ? 'pt-5' : ''"
                          cols="11"
                          v-else-if="field.typeInput == 'file'"
                        >
                          <v-text-field
                            v-if="
                              checkIfAdminOnlyForDisabled(zereg, info, field)
                            "
                            :value="
                              field.source
                                ? field.source
                                : 'Зөвхөн менежерт зориулагдсан'
                            "
                            :label="field.label"
                            dense
                            disabled
                          >
                          </v-text-field>
                          <v-row
                            v-else
                            no-gutters
                            :id="`fileInput-${zindex}-${index}-${findex}`"
                          >
                            <v-col
                              class="pa-0 mt-n2 mr-5"
                              v-if="
                                field.sourceName ||
                                (selectedZereg.alreadyDone && !$attrs.isAdmin)
                              "
                              cols="7"
                            >
                              <p
                                style="
                                  display: inline-block;
                                  max-width: 100%;
                                  line-height: 1;
                                "
                              >
                                {{ field.label }}

                                <br />
                                <a
                                  v-if="field.sourceName"
                                  style="
                                    display: inline-block;
                                    font-size: 14px;
                                    line-height: 1;
                                  "
                                  target="_blank"
                                  :href="field.source"
                                  class="blue--text mt-1"
                                >
                                  {{ field.sourceName }}
                                  ({{ bytesToMB(field.sourceSize) }})
                                </a>
                                <span v-else class="red--text">
                                  Гэрчилгээ файлаар оруулаагүй.
                                </span>
                              </p>
                            </v-col>

                            <v-btn
                              elevation="0"
                              class="mr-2"
                              :class="
                                field.sourceName
                                  ? ' grey-lighten-3 mt-n1'
                                  : ' bg-gradient-warning mt-1 white--text'
                              "
                              small
                              v-if="
                                !selectedZereg ||
                                !selectedZereg.alreadyDone ||
                                $attrs.isAdmin
                              "
                              @click="
                                btnFunctionHandler(
                                  field,
                                  `fileInput-${zindex}-${index}-${findex}`
                                )
                              "
                              :disabled="
                                (selectedZereg &&
                                  selectedZereg.alreadyDone &&
                                  !$attrs.isAdmin) ||
                                (typeof field.index == 'number' &&
                                  fileSaving[field.index])
                              "
                            >
                              <span v-if="field.sourceName"> Файл устгах </span>
                              <span v-else> Файл хавсаргах </span>
                            </v-btn>
                            <v-file-input
                              :style="field.sourceName ? 'display: none' : ''"
                              v-if="
                                !selectedZereg ||
                                !selectedZereg.alreadyDone ||
                                $attrs.isAdmin
                              "
                              v-model="field.source"
                              :label="field.label"
                              accept=".pdf"
                              :rules="field.optional ? [] : [rules.required]"
                              dense
                              @change="formUpdated(field)"
                              :prepend-icon="null"
                            />
                            <template v-if="field.savedAt">
                              <small
                                :class="field.sourceName ? 'mt-0' : 'mt-2'"
                                class="green--text ml-3"
                                style="white-space: nowrap"
                              >
                                {{ pastFormattedDate(field.savedAt) }} файл
                                хадгалсан

                                <v-icon color="green" size="16" class="ml-1"
                                  >mdi-check-circle</v-icon
                                >
                              </small>
                            </template>
                          </v-row>
                          <v-progress-linear
                            indeterminate
                            color="red"
                            v-if="
                              typeof field.index == 'number' &&
                              fileSaving[field.index]
                            "
                          ></v-progress-linear>
                        </v-col>
                        <v-col
                          class="pa-0 pt-3"
                          cols="11"
                          v-else-if="field.typeInput == 'date'"
                          @click="pickDate(field, zindex, index, findex)"
                        >
                          <div class="d-flex flex-row">
                            <v-text-field
                              v-if="
                                checkIfAdminOnlyForDisabled(zereg, info, field)
                              "
                              :value="
                                field.source
                                  ? field.source
                                  : 'Зөвхөн менежерт зориулагдсан'
                              "
                              :label="field.label"
                              dense
                              disabled
                            >
                            </v-text-field>
                            <v-text-field
                              v-else-if="field.sourceType === 'auto'"
                              v-model="today"
                              :label="field.label"
                              dense
                              disabled
                            >
                            </v-text-field>
                            <v-text-field
                              v-else
                              :rules="field.optional ? [] : [rules.required]"
                              v-model="field.source"
                              :label="field.label"
                              dense
                              readonly
                            >
                            </v-text-field>
                            <template v-if="field.savedAt">
                              <small
                                class="green--text ml-3 mt-2"
                                style="white-space: nowrap"
                              >
                                {{ pastFormattedDate(field.savedAt) }}
                                хадгалсан

                                <v-icon color="green" size="16" class="ml-1"
                                  >mdi-check-circle</v-icon
                                >
                              </small>
                            </template>
                          </div>
                        </v-col>
                      </div>
                    </v-col>
                  </v-card-actions>
                </v-card>
              </div>
              <!-- <v-card v-else-if="zereg.zeregType == 2" class="card-shadow">
                  <v-card-title>
                    <span class="font-weight-bold mr-1">{{ zindex + 1 }}.</span>
                    {{ zereg.name }} ({{ zereg.zeregType }})
                  </v-card-title>
                </v-card>
                <v-card v-else-if="zereg.zeregType == 3" class="card-shadow">
                  <v-card-title>
                    <span class="font-weight-bold mr-1">{{ zindex + 1 }}.</span>
                    {{ zereg.name }} ({{ zereg.zeregType }})
                  </v-card-title>
                </v-card> -->
            </v-col>
            <div
              class="d-flex flex-row justify-center"
              v-if="
                $attrs.isAdmin &&
                selectedZereg &&
                selectedZereg._stateOfDocument < 2
              "
            >
              <v-btn
                height="60"
                width="30%"
                :disabled="
                  loading || (selectedZereg && !selectedZereg.alreadyDone)
                "
                class="mr-4 bg-gradient-danger white--text"
                @click="saveStateOfDocument('cancel')"
              >
                <div style="font-size: 18pt">Цуцлах</div>
              </v-btn>
              <v-btn
                height="60"
                width="30%"
                :disabled="
                  loading || (selectedZereg && !selectedZereg.alreadyDone)
                "
                class="mr-4 bg-gradient-success white--text"
                @click="saveStateOfDocument('approve')"
              >
                <div style="font-size: 18pt">Баталгаажуулаx</div>
              </v-btn>
            </div>
            <div
              class="d-flex flex-row justify-center"
              v-else-if="
                $attrs.isAdmin &&
                selectedZereg &&
                selectedZereg._stateOfDocument > 1
              "
            >
              <!-- <v-btn
                height="60"
                width="20%"
                v-if="selectedZereg._stateOfDocument == 3"
                class="mr-4 white--text bg-gradient-danger"
              >
                <div style="font-size: 18pt">Цуцлагдсан</div>
              </v-btn> -->
            </div>
            <div
              class="d-flex flex-row justify-center"
              v-else-if="selectedZereg"
            >
              <v-btn
                v-if="
                  (selectedZereg && selectedZereg._stateOfDocument == 0) ||
                  (selectedZereg && selectedZereg._stateOfDocument == 3)
                "
                height="60"
                width="20%"
                :disabled="
                  loading ||
                  (selectedZereg &&
                    selectedZereg.alreadyDone &&
                    selectedZereg._stateOfDocument != 3)
                "
                class="mr-4; bg-gradient-success"
                style="color: white !important"
                @click="validateAndSave"
              >
                <div style="font-size: 18pt">Илгээх</div>
              </v-btn>
            </div>
            <p
              class="red--text mr-16 d-flex flex-row justify-center text-h3"
              v-if="
                userData.role == 'teacher' &&
                selectedZereg &&
                selectedZereg.alreadyDone &&
                selectedZereg.alreadyDoneAt &&
                selectedZereg &&
                selectedZereg._stateOfDocument < 2
              "
            >
              {{ formattedDate(selectedZereg.alreadyDoneAt) }}-д илгээсэн
            </p>
            <p
              v-if="
                selectedZereg &&
                selectedZereg._stateOfDocument == 3 &&
                userData.role != 'teacher'
              "
              class="red--text text-h4 text-center"
            >
              Энэxүү xүсэлтийг цуцалсан!
            </p>

            <p
              v-if="
                selectedZereg &&
                selectedZereg._stateOfDocument == 3 &&
                userData.role == 'teacher'
              "
              class="red--text text-h4 text-center"
            >
              Энэxүү xүсэлтийг цуцалсан байна!
            </p>
          </v-form>
        </div>
      </div>
    </v-card>

    <v-dialog
      v-model="datePickerDialog"
      v-if="checkIfDateFieldExists()"
      max-width="290"
    >
      <v-date-picker
        @change="saveDate()"
        color="green"
        width="100%"
        v-model="selectedDate"
      ></v-date-picker>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
const fb = require("@/firebaseConfig.js");
const TeacherZeregs = require("./teacherJson.js");
const ManagerZeregs = require("./managerJson.js");
import { sync } from "vuex-pathify";
import moment from "moment";

export default {
  data: () => ({
    finalQuestion: null,
    teacherGeneraleInfo: null,
    generalRequirement: null,
    selectedFieldId: null,
    selectedDate: null,
    aimagduureg: [
      { text: "Архангай", value: 1 },
      { text: "Баян-Өлгий", value: 2 },
      { text: "Баянхонгор", value: 3 },
      { text: "Булган", value: 4 },
      { text: "Говь-Алтай", value: 5 },
      { text: "Говьсүмбэр", value: 6 },
      { text: "Дорноговь", value: 7 },
      { text: "Дорнод", value: 8 },
      { text: "Дундговь", value: 9 },
      { text: "Завхан", value: 10 },
      { text: "Орхон", value: 11 },
      { text: "Өвөрхангай", value: 12 },
      { text: "Өмнөговь", value: 13 },
      { text: "Сүхбаатар", value: 14 },
      { text: "Сэлэнгэ", value: 15 },
      { text: "Төв", value: 16 },
      { text: "Увс", value: 17 },
      { text: "Ховд", value: 18 },
      { text: "Хөвсгөл", value: 19 },
      { text: "Хэнтий", value: 20 },
      { text: "Дархан-Уул", value: 21 },
      { text: "Баянзүрх (дүүрэг)", value: 22 },
      { text: "Сүхбаатар (дүүрэг)", value: 23 },
      { text: "Чингэлтэй (дүүрэг)", value: 24 },
      { text: "Баянгол (дүүрэг)", value: 25 },
      { text: "Сонгинохайрхан (дүүрэг)", value: 26 },
      { text: "Хан-Уул (дүүрэг)", value: 27 },
      { text: "Налайх (дүүрэг)", value: 28 },
      { text: "Багануур (дүүрэг)", value: 29 },
      { text: "Багахангай (дүүрэг)", value: 30 },
    ],
    selectedZereg: null,
    selectedTeacher: null,
    renderComponent: true,
    selectedField: null,
    datePickerDialog: false,
    valid: false,
    rules: {
      required: (value) => !!value || "Хоосон байж болохгүй!",
    },
    driveUrl:
      "https://drive.google.com/file/d/1NSoL9FB8Kot4cn4XEr41UM-cLCjy4qsG/view?usp=sharing",
    zeregs: null,
    orignalZeregs: null,
    today: null,
    loading: false,
    alreadyDone: false,
    alreadyDoneAt: null,
    timerInterval: null,
    fileSaving: {},
  }),
  beforeDestroy() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  },
  created() {
    if (this.$attrs.selectedTeacher) {
      this.selectedTeacher = this.$attrs.selectedTeacher;
    } else {
      this.selectedTeacher = this.userData;
    }
    this.$forceUpdate();
    this.teacherGeneraleInfo = {
      name: "Ерөнxий мэдээлэл",
      typeId: "section",
      fields: [
        {
          label: "Овог",
          typeInput: "text",
          typeId: "LAST_NAME",
          sourceType: "auto",
          source: null,
        },
        {
          label: "Нэр",
          typeInput: "text",
          typeId: "FIRST_NAME",
          sourceType: "auto",
          source: null,
        },
        {
          label: "Регистр",
          typeInput: "text",
          source: null,
        },
        {
          label: "Сургуулийн байрлаx Аймаг/Дүүрэг",
          typeInput: "select",
          options: this.aimagduureg,
          source: null,
        },
        {
          label: "Ажиллаж буй сургууль, ID",
          typeInput: "text",
          typeId: "legalEntityId",
          sourceType: "auto",
          source: null,
        },
        {
          label: "Байгууллагын нэр",
          typeInput: "text",
          typeId: "organizationName",
          sourceType: "auto",
          source: null,
        },
        {
          label: "Өмчийн xэлбэр",
          typeInput: "select",
          options: [
            {
              text: "Төрийн өмчит",
              value: 1,
            },
            { text: "Xувийн өмчит", value: 2 },
          ],
          source: null,
        },
        {
          label: "Албан тушаал",
          typeInput: "text",
          typeId: "jobId",
          sourceType: "auto",
          source: null,
        },
        {
          label: "Эзэмшсэн боловсрол",
          typeInput: "text",
          source: null,
        },
        {
          label: "Ажилласан жил (Мэргэжлээрээ)",
          typeInput: "number",
          source: null,
          min: 3,
        },
        {
          label: "Ажилласан жил /нийгмийн даатгалын лавлагаа/",
          typeInput: "file",
          source: null,
        },
        {
          label: "Туxайн албан тушаалд томилогдсон тушаал",
          typeInput: "file",
          source: null,
        },
      ],
    };
    this.generalRequirement = {
      name: "Ерөнxий шалгуур",
      typeId: "section",
      fields: [
        {
          label:
            "Багш мэргэжилтэй ерөнхий боловсролын сургуульд 3-аас доошгүй жил ажилласан байх",
          typeInput: "file",
          source: null,
          indexx: 5,
        },
        {
          label: "Тухайн албан тушаалын үндсэн орон тоонд ажилладаг байх",
          typeInput: "file",
          source: null,
          indexx: 6,
        },
        {
          label:
            "Ёс зүйн зөрчил болон мэргэжлийн алдаа гаргаагүй байх тодорхойлолт /Дээд шатны байгууллагын/",
          typeInput: "file",
          source: null,
          indexx: 7,
        },
        {
          label:
            "Багш нарын зөвлөлийн хурлын тэмдэглэлийн файл оруулна уу! /75 хувиас дээш санал авсан байх/",
          typeInput: "file",
          source: null,
          indexx: 8,
        },
        {
          label:
            "Багш нарын зөвлөлийн хурлын шийдвэрийн xувийг тоон утгаaр оруулна уу!: 75 хувиас дээш байх ",
          typeInput: "number",
          source: null,
          min: 75,
        },
      ],
    };
    this.zeregs = [];

    if (this.selectedTeacher.role == "teacher") {
      this.zeregs.push(TeacherZeregs.teacherJsonZaahNew);
      this.zeregs.push(TeacherZeregs.teacherJsonZaahBat);
      this.zeregs.push(TeacherZeregs.teacherJsonTerguulehNew);
      this.zeregs.push(TeacherZeregs.teacherJsonTerguulehBat);
    } // end of teacher zaah argah zui shine

    if (this.selectedTeacher.role == "schoolmanager") {
      this.zeregs.push(ManagerZeregs.managerJsonZaahNew);
      this.zeregs.push(ManagerZeregs.managerJsonZaahBat);
      this.zeregs.push(ManagerZeregs.managerJsonTerguulehNew);
      this.zeregs.push(ManagerZeregs.managerJsonTerguulehBat);

      // zaah argach for manager
    }

    //zovloh shine

    // this.zeregs.push({
    //   name: "Зөвлөх мэргэшлийн зэрэг (Шинэ)",
    //   zeregType: 500,

    //   infos: [
    //     JSON.parse(JSON.stringify(this.teacherGeneraleInfo)),
    //     {
    //       name: "Зэргийн xүсэлтийн мэдээлэл",
    //       typeId: "section",
    //       fields: [
    //         {
    //           label: "Зэрэг xүсэлт",
    //           typeInput: "select",
    //           typeId: "zeregHuselt",
    //           sourceType: "auto",
    //           source: null,
    //           options: [
    //             { text: "Зааx аргач", value: 1 },
    //             { text: "Тэргүүлэx", value: 2 },
    //             { text: "Зөвлөx", value: 3 },
    //           ],
    //         },
    //         {
    //           label: "Xүсэлтийн төрөл",
    //           typeId: "zeregHuseltType",
    //           sourceType: "auto",
    //           typeInput: "select",
    //           source: null,
    //           options: [
    //             { text: "Шинэ", value: 1 },
    //             { text: "Бататгаx", value: 2 },
    //             { text: "Аxиулаx", value: 3 },
    //             // { text: "Xүчингүй болгоx", value: 4 },
    //           ],
    //         },

    //         {
    //           label: "Xүсэлт гаргаж буй огноо",
    //           typeInput: "date",
    //           sourceType: "auto",
    //           source: null,
    //         },
    //       ],
    //     },
    //     //zovloh shine
    //     {
    //       name: "Ерөнxий шалгуур",
    //       typeId: "section",
    //       fields: [
    //         {
    //           label:
    //             "Ёс зүйн зөрчил болон мэргэжлийн алдаа гаргаагүй байх тодорхойлолт /Дээд шатны байгууллагын/",
    //           typeInput: "file",
    //           source: null,
    //           indexx: 5,
    //         },
    //         {
    //           label:
    //             "Багш нарын зөвлөлийн хурлын тэмдэглэл /75 хувиас дээш санал авсан байх/",
    //           typeInput: "file",
    //           source: null,
    //           indexx: 7,
    //         },
    //         {
    //           label: "/75 хувиас дээш санал авсан байх/",
    //           typeInput: "number",
    //           source: null,
    //           min: 75,
    //         },
    //       ],
    //     },
    //     {
    //       name: "Сургалтын хөтөлбөрийн хэрэгжилт, арга зүй",
    //       typeId: "section",
    //       fields: [
    //         {
    //           label:
    //             "Сургалтын хөтөлбөрийн дагуу хичээлийг төлөвлөн үр дүнтэй зохион байгуулдаг байх",
    //           typeInput: "file",
    //           source: null,
    //         },
    //         {
    //           label:
    //             "Хичээл, сургалт зохион байгуулахдаа суралцагчийн ялгаатай суралцахуйг харгалзаж, дэмжлэг үзүүлдэг байх",
    //           typeInput: "file",
    //           source: null,
    //         },
    //         {
    //           label:
    //             "Явцын үнэлгээг тогмол хэрэгжүүлдэг,үр дүнд үндэслэн арга зүйгээ сайжруулдаг байх",
    //           typeInput: "file",
    //           source: null,
    //         },
    //         {
    //           label:
    //             "Боловсролын цахим, нээлттэй нөөцийг бүрдүүлэхэд орон нутаг, үндэсний түвшинд хувь нэмэр оруулсан байх",
    //           typeInput: "file",
    //           source: null,
    //         },
    //         {
    //           label:
    //             "Сургалтын нөөц хэрэглэгдэхүүнийг суралцагчдын ялгаатай хэрэгцээнд тохируулан хийж,үр дүнтэй ашигладаг, туршлагаа орон нутаг,үндэсний түвшинд хуваалцдаг байх",
    //           typeInput: "file",
    //           source: null,
    //         },
    //         {
    //           label:
    //             "Шинэлэг бүтээлч арга зүй бий болгох, технологийг турших,  хэрэгжүүлэх зорилгоор хичээлийн судалгааг манлайлан зохион байгуулж, үр дүнг  орон нутаг, бүс үндэсний түвшинд хуваалцсан байх",
    //           typeInput: "file",
    //           source: null,
    //         },
    //       ],
    //       indexx: "3.2.1",
    //     },
    //     {
    //       name: "Хамтын ажиллагаа",
    //       typeId: "section",
    //       fields: [
    //         {
    //           label:
    //             "Багшийн хөгжлийг дэмжих үндэсний төв-ийн Арга зүйн эхний шатны сургалтад хамрагдаж амжилттай төгссөн эсэх Тийм, Үгүй гэвэл доорх 3 талбарт файл хавсаргана. Тийм гэвэл төгссөн гэрчилгээг хавсаргана.",
    //           typeInput: "file",
    //           source: null,
    //           indexx: 1,
    //         },
    //         {
    //           label:
    //             "Багшийн хувийн хөгжлийн төлөвлөгөөг боловсруулан хэрэгжүүлж үр дүнг тооцсон байх",
    //           typeInput: "file",
    //           source: null,
    //           indexx: 1,
    //         },
    //         {
    //           label:
    //             "Мэргэжлийн багш нарын бүлэг багийн үйл ажиллагаанд идэвхтэй оролцдог байх ",
    //           typeInput: "file",
    //           source: null,
    //           indexx: 1,
    //         },
    //         {
    //           label:
    //             "Хүүхдийн эрхийг хамгаалах, суралцагчдын хөгжил төлөвшлийг дэмжих, үе тэнгийн дээрэлхэлт, гадуурхал, хорт зуршил, гэмт хэргээс урьдчилан сэргийлэх, суралцагчдын хөгжил төлөвшлийг дэмжихэд багш, эцэг, эх, асран хамгаалагчтай хамтран ажилладаг байх",
    //           typeInput: "file",
    //           source: null,
    //           indexx: 1,
    //         },
    //         {
    //           label:
    //             "Ажлын байранд мэргэжил, арга зүй, ур чадвараа тасралтгүй хөгжүүлэн ахиц гарсан байх",
    //           typeInput: "file",
    //           source: null,
    //           indexx: 1,
    //         },
    //         {
    //           label:
    //             "Мэргэжлийн багш нарын бүлгийн үйл ажиллагаанд идэвхтэй оролцож хамтран ажилласан байх",
    //           typeInput: "file",
    //           source: null,
    //           indexx: 1,
    //         },
    //       ],
    //       indexx: "3.2.2",
    //     },
    //     {
    //       name: "Хамт олон, эцэг эх асран хамгаалагчийн сэтгэл ханамж",
    //       typeId: "section",
    //       fields: [
    //         {
    //           label:
    //             "Ёс зүйтэй, шударга, адил тэгш харилцаж, ажил үүргээ гүйцэтгэхэд нь тусалж дэмждэг байх",
    //           typeInput: "file",
    //           source: null,
    //           indexx: 1,
    //         },
    //         {
    //           label:
    //             "Бага, дунд, ахлах ангийн хүүхдийн хөгжлийг дэмжихэд чиглэсэн үр дүнг тооцсон байх",
    //           typeInput: "file",
    //           source: null,
    //           indexx: 1,
    //         },
    //         {
    //           label:
    //             "Багшийн ёс зүй, харилцааны зөрчилгүй, бусадтай манлайлан ажилладаг, хамт олны үнэлгээгээр нотлогдсон",
    //           typeInput: "file",
    //           source: null,
    //           indexx: 1,
    //         },

    //         {
    //           label:
    //             "Хүүхэд хамгааллын болон дэмжлэгийн багийн гишүүд, эцэг эхтэй хамтран ажиллаж үр дүнд хүрсэн байх",
    //           typeInput: "file",
    //           source: null,
    //           indexx: 1,
    //         },
    //       ],
    //       indexx: "3.2.3",
    //     },
    //   ],
    // });

    // this.zeregs.push({
    //   name: "Зөвлөх мэргэшлийн зэрэг (Бататгаx)",
    //   zeregType: 600,

    //   infos: [
    //     JSON.parse(JSON.stringify(this.teacherGeneraleInfo)),
    //     {
    //       name: "Зэргийн xүсэлтийн мэдээлэл",
    //       typeId: "section",
    //       fields: [
    //         {
    //           label: "Зэрэг xүсэлт",
    //           typeInput: "select",
    //           typeId: "zeregHuselt",
    //           sourceType: "auto",
    //           source: null,
    //           options: [
    //             { text: "Зааx аргач", value: 1 },
    //             { text: "Тэргүүлэx", value: 2 },
    //             { text: "Зөвлөx", value: 3 },
    //           ],
    //         },
    //         {
    //           label: "Xүсэлтийн төрөл",
    //           typeId: "zeregHuseltType",
    //           sourceType: "auto",
    //           typeInput: "select",
    //           source: null,
    //           options: [
    //             { text: "Шинэ", value: 1 },
    //             { text: "Бататгаx", value: 2 },
    //             { text: "Аxиулаx", value: 3 },
    //             // { text: "Xүчингүй болгоx", value: 4 },
    //           ],
    //         },

    //         {
    //           label: "Xүсэлт гаргаж буй огноо",
    //           typeInput: "date",
    //           sourceType: "auto",
    //           source: null,
    //         },
    //       ],
    //     },
    //     //zovloh Бататгаx
    //     {
    //       name: "Ерөнxий шалгуур",
    //       typeId: "section",
    //       fields: [
    //         {
    //           label:
    //             "Ёс зүйн зөрчил болон мэргэжлийн алдаа гаргаагүй байх тодорхойлолт /Дээд шатны байгууллагын/",
    //           typeInput: "file",
    //           source: null,
    //           indexx: 5,
    //         },
    //         {
    //           label:
    //             "Багш нарын зөвлөлийн хурлын тэмдэглэл /75 хувиас дээш санал авсан байх/",
    //           typeInput: "file",
    //           source: null,
    //           indexx: 7,
    //         },
    //         {
    //           label: "/75 хувиас дээш санал авсан байх/",
    //           typeInput: "number",
    //           source: null,
    //           min: 75,
    //         },
    //       ],
    //     },
    //     {
    //       name: "Сургалтын хөтөлбөрийн хэрэгжилт, арга зүй",
    //       typeId: "section",
    //       indexx: "3.2.1",
    //       fields: [
    //         {
    //           label:
    //             "Суралцагчийн ялгаатай хэрэгцээг ойлгож, тэгш хамруулах талаар бусад багш нарт зөвлөж, тусалдаг байх.",
    //           typeInput: "file",
    //           source: null,
    //           indexx: 7,
    //         },
    //         {
    //           label:
    //             "Сургуулийн алсын хараа, эрхэм зорилго, зорилтыг хэрэгжүүлэхэд манлайлан ажилладаг байх",
    //           typeInput: "file",
    //           source: null,
    //           indexx: 7,
    //         },
    //         {
    //           label:
    //             "Сургалтын хөтөлбөрийн дагуу хичээлийг төлөвлөн үр дүнтэй зохион байгуулдаг байх",
    //           typeInput: "file",
    //           source: null,
    //           indexx: 7,
    //         },
    //         {
    //           label:
    //             "Хичээл, сургалт зохион байгуулахдаа суралцагчийн ялгаатай суралцахуйг харгалзаж, дэмжлэг үзүүлдэг байх",
    //           typeInput: "file",
    //           source: null,
    //           indexx: 7,
    //         },
    //         {
    //           label:
    //             "Явцын үнэлгээг тогмол хэрэгжүүлдэг,үр дүнд үндэслэн арга зүйгээ сайжруулдаг байх",
    //           typeInput: "file",
    //           source: null,
    //           indexx: 7,
    //         },
    //         {
    //           label:
    //             "Боловсролын цахим, нээлттэй нөөцийг бүрдүүлэхэд орон нутаг, үндэсний түвшинд хувь нэмэр оруулсан байх",
    //           typeInput: "file",
    //           source: null,
    //           indexx: 7,
    //         },
    //         {
    //           label:
    //             "Сургалтын нөөц хэрэглэгдэхүүнийг суралцагчдын ялгаатай хэрэгцээнд тохируулан хийж,үр дүнтэй ашигладаг, арга зүй, туршлагаа орон нутаг,үндэсний түвшинд хуваалцдаг байх",
    //           typeInput: "file",
    //           source: null,
    //           indexx: 7,
    //         },
    //         {
    //           label:
    //             "Шинэлэг бүтээлч арга зүй бий болгох, технологийг турших,  хэрэгжүүлэх зорилгоор хичээлийн судалгааг манлайлан зохион байгуулж, үр дүнг  орон нутаг, бүс үндэсний түвшинд хуваалцсан байх",
    //           typeInput: "file",
    //           source: null,
    //           indexx: 7,
    //         },
    //         {
    //           label:
    //             "Багшийн хөгжлийг дэмжих үндэсний төв-ийн Арга зүйн эхний шатны сургалтад хамрагдаж амжилттай төгссөн эсэх Тийм, Үгүй гэвэл доорх 3 талбарт файл хавсаргана. Тийм гэвэл төгссөн гэрчилгээг хавсаргана.",
    //           typeInput: "file",
    //           source: null,
    //           indexx: 7,
    //         },
    //       ],
    //     },
    //     {
    //       name: "Хамтын ажиллагаа",
    //       typeId: "section",
    //       indexx: "3.2.2",
    //       fields: [
    //         {
    //           label:
    //             "Мэргэжлийн багш нарын бүлэг багийн үйл ажиллагаанд идэвхтэй оролцдог байх",
    //           typeInput: "file",
    //           source: null,
    //           indexx: 1,
    //         },
    //         {
    //           label:
    //             "Хүүхдийн эрхийг хамгаалах, суралцагчдын хөгжил төлөвшлийг дэмжих, үе тэнгийн дээрэлхэлт, гадуурхал, хорт зуршил, гэмт хэргээс урьдчилан сэргийлэх, суралцагчдын хөгжил төлөвшлийг дэмжихэд багш, эцэг, эх, асран хамгаалагчтай хамтран ажилладаг байх",
    //           typeInput: "file",
    //           source: null,
    //           indexx: 2,
    //         },
    //         {
    //           label:
    //             "Сургууль хамт олны тулгамдсан асуудлыг шийдвэрлэхэд идэвх, санаачилгатай оролцдог байх",
    //           typeInput: "file",
    //           source: null,
    //           indexx: 3,
    //         },
    //         {
    //           label:
    //             "Орон нутгийн боловсрол, сургалтын байгууллагатай хамтран ажиллаж, арга зүй, туршлагаа бүс, үндэсний түвшинд хуваалцдаг байх",
    //           typeInput: "file",
    //           source: null,
    //           indexx: 4,
    //         },
    //         {
    //           label:
    //             "Хүүхдийн авьяас, чадварыг хөгжүүлсэн арга зүй, туршлагаа бусад багш, бүс, орон нутгийн хэмжээнд хуваалцдаг, зөвлөн тусалж, хамтран ажилладаг байх",
    //           typeInput: "file",
    //           source: null,
    //           indexx: 5,
    //         },
    //       ],
    //     },
    //   ],
    // });

    this.timerInterval = setInterval(() => {
      this.$forceUpdate();
    }, 60000);
    this.orignalZeregs = JSON.parse(JSON.stringify(this.zeregs));
    this.today = this.getTdayDateString();

    this.selectedTeacher.school.ref
      .collection("teacherZereg")
      .doc(this.selectedTeacher.id)
      .onSnapshot((doc) => {
        console.log(doc);
        if (doc.exists) {
          if (doc.data().selectedZereg) {
            if (this.$attrs.selectedZereg) {
              this.selectedZereg = this.$attrs.selectedZereg;
            } else {
              this.selectedZereg = doc.data().selectedZereg;
            }

            if (doc.data().zereg) {
              var foundZ = doc
                .data()
                .zereg.find((z) => z.zeregType == this.selectedZereg.zeregType);
              if (foundZ) {
                this.selectedZereg.alreadyDone = foundZ.finished;
                this.selectedZereg.alreadyDoneAt = foundZ.sentAt;
                this.selectedZereg._stateOfDocument = foundZ._stateOfDocument;
                this.selectedZereg.lastUpdatedAt = foundZ.lastUpdatedAt;
                this.$forceUpdate();
              }
            }
          }

          var incomingZeregs = doc.data().zereg;

          if (incomingZeregs) {
            for (var zindex = 0; zindex < this.zeregs.length; zindex++) {
              var zereg = this.zeregs[zindex];

              if (incomingZeregs[zindex]._stateOfDocument != undefined) {
                this.$set(
                  this.zeregs[zindex],
                  "_stateOfDocument",
                  incomingZeregs[zindex]._stateOfDocument
                );
              }
              if (incomingZeregs[zindex].decisionMadeAt != undefined) {
                this.$set(
                  this.zeregs[zindex],
                  "decisionMadeAt",
                  incomingZeregs[zindex].decisionMadeAt
                );
              }
              if (incomingZeregs[zindex].decisionMadeByRef != undefined) {
                this.$set(
                  this.zeregs[zindex],
                  "decisionMadeByRef",
                  incomingZeregs[zindex].decisionMadeByRef
                );
              }
              if (incomingZeregs[zindex].finished != undefined) {
                this.$set(
                  this.zeregs[zindex],
                  "finished",
                  incomingZeregs[zindex].finished
                );
              }
              if (incomingZeregs[zindex].lastUpdatedAt != undefined) {
                this.$set(
                  this.zeregs[zindex],
                  "lastUpdatedAt",
                  incomingZeregs[zindex].lastUpdatedAt
                );
              }
              if (incomingZeregs[zindex].sentAt != undefined) {
                this.$set(
                  this.zeregs[zindex],
                  "sentAt",
                  incomingZeregs[zindex].sentAt
                );
              }
              if (incomingZeregs[zindex].managerApproved != undefined) {
                this.$set(
                  this.zeregs[zindex],
                  "managerApproved",
                  incomingZeregs[zindex].managerApproved
                );
              }
              if (incomingZeregs[zindex].managerApprovedAt != undefined) {
                this.$set(
                  this.zeregs[zindex],
                  "managerApprovedAt",
                  incomingZeregs[zindex].managerApprovedAt
                );
              }

              if (zereg.infos) {
                for (var iindex = 0; iindex < zereg.infos.length; iindex++) {
                  var info = zereg.infos[iindex];
                  if (info.fields) {
                    for (
                      var findex = 0;
                      findex < info.fields.length;
                      findex++
                    ) {
                      var field = info.fields[findex];

                      // if (!(field.source == "auto")) {
                      if (
                        field.source == null &&
                        incomingZeregs[zindex] &&
                        incomingZeregs[zindex].infos &&
                        incomingZeregs[zindex].infos[iindex] &&
                        incomingZeregs[zindex].infos[iindex].fields &&
                        incomingZeregs[zindex].infos[iindex].fields[findex] &&
                        incomingZeregs[zindex].infos[iindex].fields[findex]
                          .source
                      ) {
                        if (field.typeInput == "file") {
                          if (
                            incomingZeregs[zindex].infos[iindex].fields[findex]
                              .sourcePath &&
                            incomingZeregs[zindex].infos[iindex].fields[findex]
                              .sourceName &&
                            incomingZeregs[zindex].infos[iindex].fields[findex]
                              .sourceSize
                          ) {
                            this.$set(
                              this.zeregs[zindex].infos[iindex].fields[findex],
                              "source",
                              incomingZeregs[zindex].infos[iindex].fields[
                                findex
                              ].source
                            );
                            this.$set(
                              this.zeregs[zindex].infos[iindex].fields[findex],
                              "sourceName",
                              incomingZeregs[zindex].infos[iindex].fields[
                                findex
                              ].sourceName
                            );
                            this.$set(
                              this.zeregs[zindex].infos[iindex].fields[findex],
                              "sourcePath",
                              incomingZeregs[zindex].infos[iindex].fields[
                                findex
                              ].sourcePath
                            );
                            this.$set(
                              this.zeregs[zindex].infos[iindex].fields[findex],
                              "sourceSize",
                              incomingZeregs[zindex].infos[iindex].fields[
                                findex
                              ].sourceSize
                            );
                          }
                        } else {
                          this.$set(
                            this.zeregs[zindex].infos[iindex].fields[findex],
                            "source",
                            incomingZeregs[zindex].infos[iindex].fields[findex]
                              .source
                          );
                        }
                        if (
                          incomingZeregs[zindex].infos[iindex].fields[findex]
                            .savedAt
                        ) {
                          this.$set(
                            this.zeregs[zindex].infos[iindex].fields[findex],
                            "savedAt",
                            incomingZeregs[zindex].infos[iindex].fields[findex]
                              .savedAt
                          );
                        }
                      }
                      // }
                    }
                  }
                }
              }
            }
          }
        }
      });
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    ...sync("*"),
    filteredZeregs() {
      return this.zeregs;
      // if (this.selectedTeacher) {
      //   if (this.selectedTeacher.role == "teacher" && this.zeregs)
      //     return this.zeregs.slice(0, 2);
      //   else return this.zeregs.slice(-2);
      // }
      // return [];
    },
  },
  methods: {
    checkIfAdminOnlyForDisabled(zereg, info, field) {
      if (zereg.isForAdmin) {
        if (!this.$attrs.isAdmin) {
          return true;
        }
      }
      if (info.isForAdmin) {
        if (!this.$attrs.isAdmin) {
          return true;
        }
      }
      if (field.isForAdmin) {
        if (!this.$attrs.isAdmin) {
          return true;
        }
      }
      return false;
    },
    checkIfDateFieldExists() {
      if (this.selectedFieldId) {
        if (this.zeregs) {
          if (
            this.zeregs[this.selectedFieldId.zeregIndex] &&
            this.zeregs[this.selectedFieldId.zeregIndex].infos
          ) {
            if (
              this.zeregs[this.selectedFieldId.zeregIndex].infos[
                this.selectedFieldId.infoIndex
              ] &&
              this.zeregs[this.selectedFieldId.zeregIndex].infos[
                this.selectedFieldId.infoIndex
              ].fields
            ) {
              if (
                this.zeregs[this.selectedFieldId.zeregIndex].infos[
                  this.selectedFieldId.infoIndex
                ].fields[this.selectedFieldId.fieldIndex]
              ) {
                return true;
              }
            }
          }
        }
      }
      return false;
    },
    async saveStateOfDocument(state) {
      if (state == "approve") {
        var isValid = await this.$refs.form.validate();
      } else {
        isValid = true;
      }

      if (isValid) {
        this.$swal
          .fire({
            title:
              (state == "approve" ? "Батлах" : "Цуцлах") +
              " итгэлтэй байна уу?",
            icon: "warning",
            customClass: {
              confirmButton: "btn bg-gradient-success",
              cancelButton: "btn bg-gradient-danger",
            },
            showCancelButton: true,
            confirmButtonText: "Тийм",
            cancelButtonText: "Үгүй",
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              if (state == "approve") {
                this.saveZereg(false, state);

                console.log(this.zeregs);
              } else if (state == "cancel") {
                this.saveZereg(false, state);
              }
            }
          });
      } else {
        // If the form is not valid, notify the user (or handle as needed)
        this.$swal.fire("", "Бүх талбарыг зөв бөглөнө үү!", "error");
      }
    },
    bytesToMB(bytes) {
      return (bytes / (1024 * 1024)).toFixed(2) + "MB";
    },
    disableForm() {
      if (this.loading) {
        return true;
      }

      if (this.$attrs.isAdmin) {
        if (
          this.selectedZereg &&
          typeof this.selectedZereg._stateOfDocument == "number" &&
          this.selectedZereg._stateOfDocument > 1
        ) {
          return true;
        }
      } else {
        if (
          this.selectedZereg &&
          this.selectedZereg.alreadyDone &&
          (this.selectedZereg._stateOfDocument == 1 ||
            this.selectedZereg._stateOfDocument == 2)
        ) {
          return true;
        }
      }
      return false;
    },
    deleteFile(field) {
      this.$swal
        .fire({
          title: "Файлыг устгахдаа итгэлтэй байна уу?",
          text: "Энэ үйлдлийг буцааж болохгүй.",
          icon: "warning",
          customClass: {
            confirmButton: "btn bg-gradient-success",
            cancelButton: "btn bg-gradient-danger",
          },
          showCancelButton: true,
          confirmButtonText: "Тийм",
          cancelButtonText: "Үгүй",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            try {
              fb.storageRef
                .child(field.sourcePath)
                .delete()
                .then(() => {
                  field.source = null;
                  field.sourceName = null;
                  field.sourcePath = null;
                  this.formUpdated(field);
                });
            } catch (e) {
              console.log(e);
              field.source = null;
              field.sourceName = null;
              field.sourcePath = null;
              this.formUpdated(field);
            }
          }
        });
    },
    btnFunctionHandler(field, id) {
      if (field.sourceName) {
        this.deleteFile(field);
      } else {
        this.triggerFileInput(id);
      }
    },
    _getTotalFilesNumber() {
      var counter = 0;
      if (this.zeregs && this.selectedZereg) {
        this.zeregs
          .filter((xx) => xx.zeregType == this.selectedZereg.zeregType)
          .forEach((zereg) => {
            if (zereg.infos) {
              zereg.infos.forEach((info) => {
                if (info.fields) {
                  info.fields.forEach((field) => {
                    if (!this.checkIfAdminOnlyForDisabled(zereg, info, field)) {
                      if (field.typeInput == "file") {
                        counter++;
                      }
                    }
                  });
                }
              });
            }
          });
      }
      return counter;
    },
    saveSelectedZereg() {
      if (!this.$attrs.isAdmin) {
        if (this.selectedZereg) {
          if (this.selectedZereg.zeregType == 200 && !this.$attrs.isAdmin) {
            this.$swal.fire(
              "Xэрэв БАТАТГАН өгөx xүсэлт гаргаж байгаа бол та өмнө нь ЗААВАЛ аргач зүйч болсон байxыг анxаарна уу!"
            );
          }

          var tmp = {
            name: this.selectedZereg.name,
            zeregType: this.selectedZereg.zeregType,
          };

          this.selectedTeacher.school.ref
            .collection("teacherZereg")
            .doc(this.selectedTeacher.id)
            .set(
              {
                PERSON_ID: this.selectedTeacher.PERSON_ID
                  ? this.selectedTeacher.PERSON_ID
                  : this.selectedTeacher.id,
                selectedZereg: tmp,
              },
              { merge: true }
            );
        }
      }
    },
    triggerFileInput(id) {
      const parentElement = document.querySelector(`#${id}`); // Replace with the actual parent element ID or selector
      if (parentElement) {
        const fileInput = parentElement.querySelector('input[type="file"]');
        if (fileInput) {
          fileInput.click();
        } else {
          console.error("File input element not found.");
        }
      } else {
        console.error("Parent element not found.");
      }
    },
    handleAutoText(field) {
      if (field.typeInput === "text") {
        if (field.sourceType && field.sourceType === "auto") {
          if (field.typeId == "FIRST_NAME") {
            return this.selectedTeacher.FIRST_NAME
              ? this.selectedTeacher.FIRST_NAME
              : null;
          } else if (field.typeId == "LAST_NAME") {
            return this.selectedTeacher.LAST_NAME
              ? this.selectedTeacher.LAST_NAME
              : null;
          } else if (field.typeId == "jobId") {
            return this.selectedTeacher.TYPE_NAME
              ? this.selectedTeacher.TYPE_NAME
              : null;
          } else if (field.typeId == "legalEntityId") {
            return this.selectedTeacher.school._esis_schoolInfo.legalEntityId;
          } else if (field.typeId == "organizationName") {
            return this.selectedTeacher.school._esis_schoolInfo
              .organizationName;
          }
        }
      } else if (field.typeInput == "select") {
        if (field.sourceType && field.sourceType === "auto") {
          if (field.typeId == "zeregHuselt") {
            if (this.selectedZereg) {
              for (let op of field.options) {
                if (this.selectedZereg.name.includes(op.text)) {
                  return op ? op : null;
                }
              }
            }
            return null;
          } else if (field.typeId == "zeregHuseltType") {
            if (this.selectedZereg) {
              for (let op of field.options) {
                if (this.selectedZereg.name.includes(op.text)) {
                  return op ? op : null;
                }
              }
            }
            return null;
          }
        }
      }
    },
    formUpdated(field) {
      field.savedAt = new Date();
      this.saveZereg(true);
    },
    formattedDate(date) {
      try {
        return moment(date.toDate()).format("YYYY-M-D HH:mm:ss");
      } catch (e) {
        return moment(date).format("YYYY-M-D HH:mm:ss");
      }
    },
    pastFormattedDate(val) {
      if (val != null) {
        if (!val) {
          return "-";
        }

        try {
          var date = val.toDate();
        } catch (e) {
          date = val;
        }

        var zz = moment(date).fromNow();
        zz = zz.replace("a few seconds ago", "саяхан");
        zz = zz.replace("a minute ago", "1 мин өмнө");
        zz = zz.replace("minutes", "мин");
        zz = zz.replace("days", "өдрийн");
        zz = zz.replace("a day", "1 өдрийн");
        zz = zz.replace("hours", "цагийн");
        zz = zz.replace("an hour", "1 цагийн");
        zz = zz.replace("a month", "1 сарын");
        zz = zz.replace("months", "сарын");
        zz = zz.replace("ago", "өмнө");

        return zz;
      }
      return "-";
    },
    clic(field) {
      console.log(field);
    },
    completionMeter(onlyNumber) {
      let totalFields = 0;
      let filledFields = 0;

      if (this.zeregs && this.selectedZereg) {
        this.zeregs
          .filter((xx) => xx.zeregType == this.selectedZereg.zeregType)
          .forEach((zereg) => {
            if (zereg.infos) {
              zereg.infos.forEach((info) => {
                if (info.fields) {
                  info.fields.forEach((field) => {
                    if (
                      !field.sourceType ||
                      (field.sourceType && field.sourceType != "auto")
                    ) {
                      if (
                        !this.checkIfAdminOnlyForDisabled(zereg, info, field) &&
                        !field.optional
                      ) {
                        totalFields++;
                        if (field.source) {
                          filledFields++;
                        }
                      }
                    }
                  });
                }
              });
            }
          });
      }

      if (onlyNumber) {
        return (filledFields / totalFields) * 100;
      } else if (onlyNumber == null) {
        return totalFields;
      } else {
        return `(${totalFields}/${filledFields})`;
      }
    },
    async saveZereg(autosave, state) {
      if (this.selectedZereg) {
        this.loading = true;
        if (!autosave) this.saving = true;
        console.log(this.zeregs);
        var allowed = true;
        var filesToUpload = [];

        for (let zereg of this.zeregs.filter(
          (xx) => xx.zeregType == this.selectedZereg.zeregType
        )) {
          if (zereg.infos)
            for (let info of zereg.infos) {
              if (info.fields)
                for (let field of info.fields) {
                  if (
                    field.source == null &&
                    (!field.sourceType || field.sourceType !== "auto") &&
                    !this.checkIfAdminOnlyForDisabled(zereg, info, field) &&
                    !field.optional
                  ) {
                    allowed = false;
                  }

                  if (allowed || autosave) {
                    if (field.typeInput === "text") {
                      if (field.sourceType && field.sourceType === "auto") {
                        field.source = this.handleAutoText(field);
                      }
                    }

                    if (field.typeInput === "select") {
                      if (field.sourceType && field.sourceType === "auto") {
                        field.source = this.handleAutoText(field);
                      }
                    }

                    if (field.typeInput === "date") {
                      if (field.sourceType && field.sourceType === "auto") {
                        field.source = this.today;
                      }
                    }

                    if (field.typeInput === "file") {
                      if (
                        field.source != null &&
                        field.source instanceof File
                      ) {
                        if (field.source) console.log(field.source);
                        if (field.sourcePath) {
                          fb.storageRef.child(field.sourcePath).delete();
                        }

                        field.index = new Date().getTime();
                        filesToUpload.push(field);
                      } else if (
                        field.source != null &&
                        typeof field.source != "string"
                      ) {
                        console.log(field, "NOT");
                      }
                    }
                  }
                }
            }
        }

        console.log(filesToUpload);

        if (allowed || autosave || state == "cancel") {
          for (var fieldOfFile of filesToUpload) {
            this.fileSaving[fieldOfFile.index] = true;
            var fileData = await this.uploadFile(fieldOfFile);
            this.fileSaving[fieldOfFile.index] = false;
            if (fileData) {
              for (let zereg of this.zeregs) {
                if (zereg.infos)
                  for (let info of zereg.infos) {
                    if (info.fields)
                      for (let field of info.fields) {
                        if (field.index == fieldOfFile.index) {
                          field.source = fileData.fileUrl;
                          field.sourceName = fileData.fileName;
                          field.sourcePath = fileData.filePath;
                          field.sourceSize = fileData.fileSize;
                        }
                      }
                  }
              }
            } else {
              console.error("File upload failed");
              if (!autosave)
                this.$swal.fire({
                  title: "Алдаа!",
                  text: "Файлыг ачаалах явцад алдаа гарлаа.",
                  icon: "error",
                });
              return;
            }
          }

          var tmp = {
            name: this.selectedZereg.name,
            zeregType: this.selectedZereg.zeregType,
          };

          var tmpZereg = [];

          for (var zindex = 0; zindex < this.zeregs.length; zindex++) {
            var zereg = this.zeregs[zindex];

            var tmp2 = {
              lastUpdatedAt: new Date(),
              name: zereg.name,
              zeregType: zereg.zeregType,
              infos: [],
            };

            if (zereg.zeregType == this.selectedZereg.zeregType) {
              tmp2.finished = autosave
                ? zereg.finished
                  ? zereg.finished
                  : false
                : true;
              tmp2.sentAt = autosave
                ? zereg.sentAt
                  ? zereg.sentAt
                  : null
                : new Date();
              tmp2._stateOfDocument = autosave
                ? zereg._stateOfDocument
                  ? zereg._stateOfDocument
                  : 0
                : 1;
              if (this.$attrs.isAdmin && state) {
                if (state == "approve") {
                  tmp2.managerApproved = true;
                  tmp2.managerApprovedAt = new Date();
                }
                tmp2._stateOfDocument = state == "approve" ? 2 : 3;
                tmp2.decisionMadeAt = new Date();
                tmp2.decisionMadeByRef = this.userData.ref;
                tmp2.lastUpdatedAt = this.selectedZereg.lastUpdatedAt;
                tmp2.finished = this.selectedZereg.alreadyDone;
                tmp2.sentAt = this.selectedZereg.alreadyDoneAt;
              }
            } else {
              tmp2.finished =
                zereg.finished != undefined ? zereg.finished : null;
              tmp2.sentAt = zereg.sentAt != undefined ? zereg.sentAt : null;
              tmp2._stateOfDocument =
                zereg._stateOfDocument != undefined
                  ? zereg._stateOfDocument
                  : null;
              tmp2.decisionMadeAt =
                zereg.decisionMadeAt != undefined ? zereg.decisionMadeAt : null;
              tmp2.decisionMadeByRef =
                zereg.decisionMadeByRef != undefined
                  ? zereg.decisionMadeByRef
                  : null;
              tmp2.lastUpdatedAt =
                zereg.lastUpdatedAt != undefined ? zereg.lastUpdatedAt : null;
              tmp2.managerApproved =
                zereg.managerApproved != undefined
                  ? zereg.managerApproved
                  : null;
              tmp2.managerApprovedAt =
                zereg.managerApprovedAt != undefined
                  ? zereg.managerApprovedAt
                  : null;
            }

            tmpZereg.push(tmp2);
            if (zereg.infos) {
              for (var iindex = 0; iindex < zereg.infos.length; iindex++) {
                var info = zereg.infos[iindex];
                tmpZereg[zindex].infos.push({
                  name: info.name,
                  typeId: info.typeId,
                  fields: [],
                });
                if (info.fields) {
                  for (var findex = 0; findex < info.fields.length; findex++) {
                    var field = info.fields[findex];

                    var tmpp = {
                      label: field.label,
                      source: field.source,
                    };

                    if (field.typeId) {
                      tmpp.typeId = field.typeId;
                    }

                    if (field.savedAt) {
                      tmpp.savedAt = field.savedAt;
                    }

                    if (field.sourceName) {
                      tmpp.sourceName = field.sourceName;
                      tmpp.sourcePath = field.sourcePath;
                      if (field.sourceSize) tmpp.sourceSize = field.sourceSize;
                    }

                    tmpZereg[zindex].infos[iindex].fields.push(tmpp);
                  }
                }
              }
            }
          }

          console.log(tmpZereg);

          if (this.$attrs.isAdmin) {
            this.selectedTeacher.school.ref
              .collection("teacherZereg")
              .doc(this.selectedTeacher.id)
              .set(
                {
                  zereg: tmpZereg,
                },
                { merge: true }
              )
              .then(() => {
                if (!autosave) {
                  this.$swal.fire({
                    title: "Амжилттай!",
                    text: "Амжилттай хадгалагдсан!",
                    icon: "success",
                  });

                  // this.zeregs = JSON.parse(JSON.stringify(this.orignalZeregs)); //clear
                }

                console.log(
                  "saved to " +
                    this.selectedTeacher.school.ref.path +
                    "/teacherZereg/" +
                    this.selectedTeacher.id
                );
              });
          } else {
            this.selectedTeacher.school.ref
              .collection("teacherZereg")
              .doc(this.selectedTeacher.id)
              .set({
                PERSON_ID: this.selectedTeacher.PERSON_ID
                  ? this.selectedTeacher.PERSON_ID
                  : this.selectedTeacher.id,
                selectedZereg: tmp,
                zereg: tmpZereg,
              })
              .then(() => {
                if (!autosave) {
                  this.$swal.fire({
                    title: "Амжилттай!",
                    text: "Зэрэг xүсэлт амжилттай илгээгдлээ.",
                    icon: "success",
                  });

                  // this.zeregs = JSON.parse(JSON.stringify(this.orignalZeregs)); //clear
                }

                console.log(
                  "saved to " +
                    this.selectedTeacher.school.ref.path +
                    "/teacherZereg/" +
                    this.selectedTeacher.id
                );
              });
          }
        } else {
          if (!autosave) {
            this.$swal.fire({
              title: "Алдаа!",
              text: "Бүх талбарыг бөглөнө үү!",
              icon: "error",
            });
          }
        }
        this.loading = false;
      }
    },
    async uploadFile(fieldOfFile) {
      var file = fieldOfFile.source;
      var fileName =
        new Date().getTime() +
        "-" +
        (this.selectedZereg ? this.selectedZereg.zeregType : "NaN") +
        "-" +
        file.name;
      var fileSize = file.size;
      console.log(fileName, file);

      const maxFileSize = 10 * 1024 * 1024; // 10 MB
      if (file.size > maxFileSize) {
        this.$swal.fire({
          title: "Алдаа!",
          text: `Файлын (${fileName}) хэмжээ 10MB-с их байна.`,
          icon: "error",
        });
        return null;
      }

      var filePath = `teacherZeregUploads/schoolId-${this.selectedTeacher.school.ref.id}/personId-${this.selectedTeacher.id}/${fileName}`;

      // Upload the file to Firebase Storage
      const fileRef = fb.storageRef.child(filePath);

      try {
        const uploadTaskSnapshot = await fileRef.put(file);

        const downloadUrl = await uploadTaskSnapshot.ref.getDownloadURL();

        return {
          fileName: fileName,
          filePath: filePath,
          fileUrl: downloadUrl,
          fileSize: fileSize,
        };
      } catch (e) {
        console.error("Error uploading file:", e);
        return null;
      }
    },
    async validateAndSave() {
      // Validate the form
      const isValid = await this.$refs.form.validate();

      if (isValid) {
        // If the form is valid, save to Firebase
        this.$swal({
          title: "Илгээxэд бэлэн боллоо. Илгээx үү?",
          text: "Илгээсний дараа ДАXИН засаx боломжгүй. Менежертээ xэлж ЦУЦЛУУЛЖ засаx боломжтой!",
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn bg-gradient-success",
            cancelButton: "btn bg-gradient-danger",
          },
          confirmButtonText: "Тийм",
          cancelButtonText: "Үгүй",
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.saveZereg();
          }
        });
      } else {
        // If the form is not valid, notify the user (or handle as needed)
        this.$swal.fire("", "Бүх талбарыг зөв бөглөнө үү!", "error");
      }
    },
    getMinMaxRules(min, max) {
      const rules = [];

      // Add min rule if min is defined
      if (typeof min === "number") {
        rules.push(
          (value) =>
            value >= min || `Утга нь ${min}-аас их буюу тэнцүү байх ёстой`
        );
      }

      // Add max rule if max is defined
      if (typeof max === "number") {
        rules.push(
          (value) =>
            value <= max || `Утга нь ${max}-аас бага буюу тэнцүү байх ёстой`
        );
      }

      return rules;
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    async forceRerender() {
      this.renderComponent = false;
      await this.$nextTick();
      this.renderComponent = true;
    },
    saveDate() {
      if (
        this.zeregs[this.selectedFieldId.zeregIndex].infos[
          this.selectedFieldId.infoIndex
        ].fields[this.selectedFieldId.fieldIndex].typeInput == "date"
      ) {
        this.$set(
          this.zeregs[this.selectedFieldId.zeregIndex].infos[
            this.selectedFieldId.infoIndex
          ].fields[this.selectedFieldId.fieldIndex],
          "source",
          this.selectedDate
        );
        this.datePickerDialog = false;
        this.selectedDate = null;

        this.$set(
          this.zeregs[this.selectedFieldId.zeregIndex].infos[
            this.selectedFieldId.infoIndex
          ].fields[this.selectedFieldId.fieldIndex],
          "savedAt",
          new Date()
        );

        this.saveZereg(true);
      } else {
        console.log("not date field");
      }
    },
    getTdayDateString() {
      let date = new Date();
      let formattedDate = date.toISOString().split("T")[0];
      return formattedDate;
    },
    pickDate(field, zeregIndex, infoIndex, fieldIndex) {
      if (field.sourceType != "auto") {
        this.selectedFieldId = {};

        this.selectedFieldId.zeregIndex = zeregIndex;
        this.selectedFieldId.infoIndex = infoIndex;
        this.selectedFieldId.fieldIndex = fieldIndex;

        this.datePickerDialog = true;
      }
    },
    goToDriveLink() {
      window.open(this.driveUrl, "_blank"); // Opens in a new tab
    },
  },
};
</script>
